import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle, GridWidths } from "@insite/mobius/GridItem";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { MappedLink } from "@nishtech/Overrides/Widgets/Header/MainNavigation";
import CustomApplicationState from "@nishtech/Store/Nishtech/Data/CustomApplicationState/CustomApplicationState";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface DealsSectionStyles {
    dealsContainer: GridContainerProps;
    dealsFirstGridItem: GridItemProps;
    dealsSecondGridItem: GridItemProps;
    leftMegaMenuItem: GridItemProps;
    leftMegaMenuLink: LinkPresentationProps;
    rightMegaMenuItem: GridItemProps;
    rightMegaMenuStaticLink: GridItemProps;
    rightMegaMenuLink: LinkPresentationProps;
    rightMegaMenuChildLink: LinkPresentationProps;
    PromoGridItem: GridItemProps;
    PromoOuterGridItem: GridItemProps;
    PromoImage: LazyImageProps;
    PromoImageDescription: LinkPresentationProps;
    PromoImageDetailInfo: TypographyProps;
    PromoButtonLink: LinkPresentationProps;
    PromoDangerouslyTag?: GridItemProps;
}

export const dealsSectionStyles: DealsSectionStyles = {
    dealsContainer: {
        css: css`
            > ${GridOffset} {
                width: 100%;
                margin: auto;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                            // padding: 0px 9%;
                        `,
                ])}
            }
        `,
    },
    dealsFirstGridItem: {
        css: css`
            padding: 0px;
            max-width: 20%;
            flex-basis: 20%;
            flex-direction: column;
            /* border-right: 2px solid ${getColor("common.border")}; */
            overflow: hidden auto;
            > li {
                max-width: 100%;
                flex-basis: 100%;
                padding: 0px 15px 10px;
                margin-left: 5px;
                font-size: 12px;
                width: 100%;
                max-height: 28px;
            }
        `,
    },
    dealsSecondGridItem: {
        css: css`
            max-width: 80%;
            flex-basis: 80%;
            padding: 0px 15px;
            > div[class^="Wrapper"] {
                max-width: 100%;
                flex-basis: 100%;
                > div[class^="ContentWrapper"], .wrapper {
                    display: flex;
                    flex-basis: 100%;
                    max-width: 100%;
                    flex-direction: row;
                    gap: 20px;
                    padding: 0px 0px 10px;
                    > div {
                        color: ${getColor("text.main")};
                        width: calc(100% / 4);
                        img {
                            width: 100%;
                            height: 150px;
                        }
                        > div > a {
                            font-size: 12px;
                            font-weight: bold;
                            margin-top: 10px;
                            width: 100%;
                            span {
                                color: ${getColor("text.main")};
                            }
                        }
                        p {
                            padding: 0;
                            font-size: 12px;
                            margin: 0;
                            font-weight: normal;
                            line-height: normal;
                        }
                        > a {
                            display: inline-block;
                            padding: 0;
                            font-size: 12px;
                            font-weight: normal;
                            line-height: normal;
                            text-transform: none;
                            text-decoration: underline;
                            text-underline-offset: 2px;
                            span {
                                color: ${getColor("text.main")};
                            }
                        }
                    }
                }
            }
        `,
    },
    leftMegaMenuItem: {},
    leftMegaMenuLink: {
        css: css`
            > span {
                color: ${getColor("text.main")} !important;
                font-weight: bold !important;
            }
            &:hover {
                > span {
                    text-decoration: underline;
                }
            }
        `,
    },
    rightMegaMenuItem: {},
    rightMegaMenuStaticLink: {
        css: css`
            color: ${getColor("text.main")};
            flex-basis: 100%;
            max-width: 100%;
            padding: 0px 15px;
        `,
    },
    rightMegaMenuLink: {
        css: css`
            font-weight: bold;
        `,
    },
    rightMegaMenuChildLink: {},
    PromoGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: row;
        `,
    },
    PromoOuterGridItem: {
        css: css`
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: column;
        `,
    },
    PromoImage: {
        css: css`
            width: 200px;
            height: 200px;
        `,
    },
    PromoImageDescription: {
        css: css`
            font-size: 12px;
            font-weight: bold;
            margin-top: 10px;
            width: 100%;
        `,
    },
    PromoImageDetailInfo: {
        css: css`
            color: ${getColor("text.main")};
            padding: 0;
            font-size: 12px;
            margin: 0;
            font-weight: normal;
            line-height: normal;
        `,
    },
    PromoButtonLink: {
        css: css`
            display: inline-block;
            padding: 0;
            font-size: 12px;
            font-weight: normal;
            line-height: normal;
            text-transform: none;
            text-decoration: underline;
        `,
    },
    PromoDangerouslyTag: {
        css: css`
            color: ${getColor("text.main")};
            max-width: 100%;
            flex-basis: 100%;
        `,
    },
};

interface OwnProps {
    link: MappedLink;
    onHandleClose: Function;
    zoneId: string;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        session: state.context.session,

    };
};

const mapDispatchToProps = {
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const DealsSectionComponent = ({ link, onHandleClose
    , zoneId
    , session }: Props) => {
    const [activeChildIndex, setActiveChildIndex] = useState<number | null>(null);
    const handleMouseEnter = (index: number, categoryName: string) => {
        setActiveChildIndex(index);
    };
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;


    const handleMouseLeave = () => {
        setActiveChildIndex(null);
    };

    useEffect(() => {
    }, []);

    useEffect(() => {
        const childLinks = document.querySelectorAll(".child-link");
        const handleLinkClick = () => {
            onHandleClose();
        };
        childLinks.forEach(link => {
            link.addEventListener("click", handleLinkClick);
        });

        return () => {
            childLinks.forEach(link => {
                link.removeEventListener("click", handleLinkClick);
            });
        };
    }, [isAuthenticated
    ]);

    const styles = dealsSectionStyles;

    return (
        <>
            <GridContainer {...styles.dealsContainer}>
                <GridItem {...styles.dealsFirstGridItem} className="parent-container">
                    <Zone contentId={zoneId} zoneName="dealsMenu" />
                </GridItem>
                <GridItem {...styles.dealsSecondGridItem}>
                    <Zone contentId={zoneId} zoneName="promoContent" />
                </GridItem>
            </GridContainer>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(DealsSectionComponent);
